export const environment = {
  apiUrl: 'http://localhost:3030',
  version: '25.10.02',
  production: true,
  customLogo: null
  // customLogo: "dark-user-bg2x.png"
};



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/environments/environment.ts